require('./bootstrap');
require('./global');
require('./solicitudes/listado');
require('./solicitudes/detalle');

require('jquery-validation');
require('jquery-validation/dist/localization/messages_es');

import 'select2';